import React from 'react';
import { Link } from 'react-router-dom';

// NeoPass Logo SVG Component
const LogoSVG = ({ className = "h-6 w-auto" }) => (
  <svg 
    className={className}
    viewBox="0 0 140 32" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Icon - Stylized "N" with gradient accent */}
    <rect x="0" y="4" width="24" height="24" rx="4" fill="currentColor" fillOpacity="0.1" stroke="currentColor" strokeOpacity="0.3" strokeWidth="1"/>
    <path 
      d="M6 22V10L12 18L18 10V22" 
      stroke="url(#logo-gradient)" 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Text - "NeoPass" */}
    {/* <text x="32" y="22" fill="currentColor" fontFamily="Inter, sans-serif" fontWeight="500" fontSize="18">
      NeoPass
    </text> */}
    
    {/* Gradient Definition */}
    <defs>
      <linearGradient id="logo-gradient" x1="6" y1="10" x2="18" y2="22" gradientUnits="userSpaceOnUse">
        <stop stopColor="hsl(45, 93%, 58%)" />
        <stop offset="1" stopColor="hsl(45, 93%, 48%)" />
      </linearGradient>
    </defs>
  </svg>
);

// Simple Icon Only Version - White Logo
const LogoIcon = ({ className = "h-8 w-8" }) => (
  <svg 
    className={className}
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M4.6109 4.68601C4.72546 4.54406 4.90822 4.47575 5.0878 4.50778L16.575 6.55656C16.6715 6.57377 16.7608 6.61896 16.8318 6.68651L19.3446 9.07676C19.5379 9.26064 19.5528 9.5639 19.3784 9.76583L11.122 19.3268C11.0084 19.4583 10.8347 19.5214 10.6632 19.4935C10.4917 19.4656 10.347 19.3506 10.281 19.1898L4.53742 5.18979C4.46819 5.02103 4.49635 4.82796 4.6109 4.68601ZM6.19646 6.59904L10.4853 17.053L11.2894 10.6786L6.19646 6.59904ZM12.2688 10.9045L11.4468 17.4207L17.7491 10.1226L12.2688 10.9045ZM17.9075 9.08986L13.7298 9.68594L16.4453 7.69901L17.9075 9.08986ZM15.2483 7.33573L6.84451 5.83688L11.8343 9.83381L15.2483 7.33573Z" 
      fill="#ffffff"
    />
  </svg>
);

// Full Logo Component with Link
const Logo = ({ to = "/", className = "", iconOnly = false, size = "default" }) => {
  const sizeClasses = {
    small: iconOnly ? "h-5 w-5" : "h-5 w-auto",
    default: iconOnly ? "h-6 w-6" : "h-6 w-auto",
    large: iconOnly ? "h-8 w-8" : "h-8 w-auto",
  };

  return (
    <Link to={to} className={`flex items-center gap-2 text-white ${className}`}>
      {iconOnly ? (
        <LogoIcon className={sizeClasses[size]} />
      ) : (
        <>
          <LogoIcon className={sizeClasses[size]} />
          <span className="text-lg font-medium">NeoPass</span>
        </>
      )}
    </Link>
  );
};

export { Logo, LogoSVG, LogoIcon };
export default Logo;
